import React from 'react';
import emailjs from 'emailjs-com';


export default function Contact() {

  function sendEmail(e) {
    e.preventDefault();
 

    emailjs.sendForm('service_i587l4a','template_6if0ln8', e.target, 'user_jVxZbyMfkf5yciYw5vCNG')
      .then((result) => {
          window.alert('Email sent!')
          document.getElementById("contactForm").reset(); 
      }, (error) => {
          console.log(error.text);
      });
  }

  return (
      <div>
        <div id="contact">
          <div className="container">
            <div className="col-md-8">
              <div className="row">
                <div className="section-title">
                  <h2>Get In Touch</h2>
                  <p>
                    Please fill out the form below to send us an email and we
                    will get back to you as soon as possible.
                  </p>
                </div>
                <form name="sentMessage" id="contactForm" Validate onSubmit={sendEmail}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder="Name"
                          required="required"
                          name="user_name"
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="tel"
                          id="phone"
                          className="form-control"
                          placeholder="Phone Number"
                          required="required"
                          name="phone_number"                       />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Email"
                          required="required"
                          name="user_email"
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success"></div>
                  <button type="submit" className="btn btn-custom btn-lg">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
            <div className="col-md-3 col-md-offset-1 contact-info">
              <div className="contact-item">
                <h3>Contact Info</h3>
                <p>
                  <span>
                    <i className="fa fa-map-marker"></i> Address
                  </span>
                  <a href="https://www.google.com/maps/place/Biocare+Pharma+Group/@29.9854317,31.3094947,21z/data=!4m5!3m4!1s0x14583955104da1e1:0xf2fab4c52376277b!8m2!3d29.9854189!4d31.3095411"   
                     target="_blank" rel="noopener noreferrer">                  
                    <p>2110, El Akram Ibn Aby Al Akram, Mearag City, Cairo, Egypt</p>
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-phone"></i> Phone
                  </span>{" "}
                  +20 100 004 0992
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> Email
                  </span>{" "}
                  ehab_salama80@hotmail.com
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="social">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/Biocare-Pharma-Group-268803763627370/"
                        target="_blank" rel="noopener noreferrer"
                      >
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="footer">
          <div className="container text-center">
            <p>
              &copy; 2021 BioCare Pharma. Designed and built by{" "}
              <a href="https://www.linkedin.com/in/ali-sahmoud/" target="_blank" rel="noopener noreferrer">
                Ali Sahmoud
              </a>
            </p>
          </div>
        </div>
      </div>
    );
}
